export default function NothingMoreToShow() {
    return (
        <p style={{ textAlign: "center" }}>
            <b>There is nothing more to show</b>
        </p>
    );
}